import { useEffect, useState } from "react"

const PHONE_BREAKPOINT = 768

type UseViewportBelowOptions = {
  breakpoint?: number
}

/**
 * Viewport-only breakpoint hook that returns true when viewport width is below the breakpoint.
 * Unlike useIsMobile, this does NOT factor in Canvas open state—purely viewport dimensions.
 */
export function useViewportBelow({ breakpoint = PHONE_BREAKPOINT }: UseViewportBelowOptions = {}) {
  const [isBelow, setIsBelow] = useState<boolean>(() => {
    if (typeof window === "undefined") return false
    return window.innerWidth < breakpoint
  })

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint - 1}px)`)

    const handleChange = () => {
      setIsBelow(window.innerWidth < breakpoint)
    }

    mediaQuery.addEventListener("change", handleChange)
    setIsBelow(window.innerWidth < breakpoint)

    return () => mediaQuery.removeEventListener("change", handleChange)
  }, [breakpoint])

  return isBelow
}
